if (!customElements.get('card-product-swatches')) {
  class CardProductSwatches extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onSwatchClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onSwatchClick);
    }

    onSwatchClick = (event) => {
      const link = event.target.closest('.card-product-swatches__link');
      if (!link || !this.contains(link)) return;

      const mediaSrc = link.getAttribute('data-media-src');
      if (!mediaSrc) return;

      event.preventDefault();

      const card = this.closest('.card-wrapper') || this.closest('.card');
      if (!card) return;

      const media = card.querySelector('.card__media .media') || card.querySelector('.card__media');
      const image =
        card.querySelector('.card__media-image') ||
        media?.querySelector('img') ||
        card.querySelector('.card__media img');
      if (!image) return;

      const srcset = link.getAttribute('data-media-srcset');
      if (srcset) {
        image.srcset = srcset;
      } else {
        image.removeAttribute('srcset');
      }
      image.src = mediaSrc;
      image.loading = 'eager';

      const colorName = link.getAttribute('title') || link.getAttribute('aria-label');
      if (colorName) {
        image.alt = colorName;
      }

      media?.querySelectorAll('img').forEach((img, index) => {
        if (index > 0) img.setAttribute('hidden', '');
      });
      card.classList.add('card-wrapper--swatch-preview');

      const variantUrl = link.getAttribute('href');
      if (variantUrl) {
        card.querySelectorAll('a.full-unstyled-link').forEach((cardLink) => {
          cardLink.setAttribute('href', variantUrl);
        });
      }

      this.querySelectorAll('.card-product-swatches__link').forEach((item) => {
        item.classList.toggle('card-product-swatches__link--active', item === link);
      });
    };
  }

  customElements.define('card-product-swatches', CardProductSwatches);
}
